<template>
    <div v-if="Array.isArray(value)">
        <div v-if="value.length === 0">{{ placeholder || '--' }}</div>
        <div v-else v-for="(item, index) in value" :key="index">{{ item }}</div>
    </div>
    <div v-else>{{ ['', undefined, null].includes(value) ? placeholder || '--' : value }}</div>
</template>

<script>
export default {
    name: 'formatDefault',
    props: ['value', 'placeholder']
};
</script>
